export const globalStyles = theme => ({
  '@global': {
    // remove underlining of text in buttons / list items / grids rendered as links
    '.MuiButton-root:hover, .MuiListItem-root:hover, .MuiGrid-root:hover': {
      textDecoration: 'none'
    },
    '& .MuiTypography-h1': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 26,
      fontWeight: 400,
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(4)
      },
      '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(1.5)
      }
    },
    '& .MuiTypography-h2': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 22,
      fontWeight: 400,
      marginTop: theme.spacing(3.5),
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(2.5)
      },
      '& > .MuiSvgIcon-root:first-child': {
        marginRight: theme.spacing(1.5),
        width: 20,
        height: 20
      }
    },
    '& .MuiTypography-h3': {
      fontSize: 18,
      fontWeight: 400,
      marginTop: theme.spacing(3),
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(2)
      }
    },
    '& .MuiTypography-h4': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 500,
      marginTop: theme.spacing(2),
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(1)
      },
      '& .MuiSvgIcon-root': {
        marginRight: 6,
        width: 14,
        height: 14
      }
    },
    '& .MuiTypography-body1': {
      fontSize: 14,
      lineHeight: '24px',
      '&.MuiTypography-gutterBottom': {
        marginBottom: theme.spacing(2)
      }
    },
    // increase font size and padding for all tooltips
    '.MuiTooltip-tooltip': {
      fontSize: 12,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: 6,
      paddingBottom: 6
    },
    '& code': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
      borderRadius: 3,
      padding: '2px 5px',
      margin: '0 2px',
      border: '1px solid',
      borderColor: theme.palette.action.selected,
      whiteSpace: 'nowrap',
      fontSize: 12,
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      '& .MuiLink-root': {
        color: theme.palette.text.primary
      }
    },
    '& pre code': {
      margin: 0,
      display: 'block',
      lineHeight: '18px',
      padding: '6px 10px',
      whiteSpace: 'unset',
      overflow: 'auto'
    }
  }
});

export default () => ({
  root: {
    display: 'flex',
    height: '100%'
  }
});
